import { FormControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/*
* Required Validator for any field except DATES
* */
export function RequiredValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value === null || value === '' || value === undefined || (value && value.toString().trim() === '')) ? {
    required: true,
    errorMessage: 'errors.required'
  } : null;
}


/*
* Required Validator for any field except DATES
* */
export function RequiredDateValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value === null || value === '' || value === undefined) ? {
    required: true,
    errorMessage: 'errors.dateFormat'
  } : null;
}

export function ZipCodeValidator(control: UntypedFormControl) {
  const value = control.value ? control.value.toUpperCase() : null;
  const ZIPCODE_REGEX = /(^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/;

  return (value && !ZIPCODE_REGEX.test(value)) ? { required: true, errorMessage: 'errors.zipCode' } : null;
}

export function SameProvince(province: string, errorMessage: string): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const value = control.value;

    if (value?.toLowerCase() !== province?.toLowerCase()) {
      return { notSameProvince: true, errorMessage };
    }
  };
}

export function EmailValidator(control: UntypedFormControl) {
  const value = control.value;
  const EMAIL_REGEX = /\S+@\S+\.\S+/;

  return (value && !EMAIL_REGEX.test(value)) ? { required: true, errorMessage: 'errors.email' } : null;
}

/*
* Min Length Validator for username for text field
* */
export function MinUsernameLengthValidator(control: UntypedFormControl) {
  const value = control.value;

  return ((value && value.length < 3)) ? { required: true, errorMessage: 'errors.userNameMin' } : null;
}

export function NumberValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && isNaN(value)) ? { required: true, errorMessage: 'errors.numbersOnly' } : null;
}

export function PositiveValueValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && !isNaN(value) && value <= 0) ? { required: true, errorMessage: 'errors.positiveValue' } : null;
}

export function NonNegativeValueValidator(control: UntypedFormControl) {
  const value = control.value;

  return (value && !isNaN(value) && value < 0) ? { required: true, errorMessage: 'errors.nonNegativeValue' } : null;
}

export function YearValidator(control: UntypedFormControl) {
  const value = control.value;
  const pattern = /^(19|20)\d{2}$/;

  return (value && !pattern.test(value)) ? { required: true, errorMessage: 'errors.year' } : null;
}

